module.exports = __webpack_public_path__ + "img/nav-09.5739bc12.jpg";